import React from "react";

export const PagoExpress = () => {
  return (
    <span className="terminos-condiciones">
      <p className="text-center">
        <strong>
          <u>
            TÉRMINOS Y CONDICIONES DE LA HERRAMIENTA “PAGO EXPRESS” DE EDENRED
            ARGENTINA S.A.
          </u>
        </strong>
      </p>
      <p>Última actualización: 05/05/2020</p>
      <p>
        Los presentes términos y condiciones (en adelante los “T&C”) regulan el
        uso y funcionamiento de la herramienta web “Pago Express” (en adelante
        la “Herramienta”) que EDENRED ARGENTINA S.A., CUIT 30-62360867-7 (en
        adelante “EDENRED”) pone a disposición de Ud., en su calidad de comercio
        adherido a la red de EDENRED (en adelante, “Ud.”), a través del sitio
        web{" "}
        <a href="https://www.edenred.com.ar/comercios">
          {" "}
          https://www.edenred.com.ar/comercios
        </a>
        . Previo al uso de la Herramienta, Ud. deberá aceptar los presentes T&C
        de la Herramienta. Dicha aceptación se efectiviza tildando el recuadro
        destinado a tal fin, al pie de los presentes.
      </p>
      <p>
        Para ello, deberá leer este documento con atención y detenimiento. Si
        luego de la lectura de estos T&C Ud. tuviera cualquier duda respecto de
        los mismos, podrá contactarse con EDENRED a través de cualquiera de los
        puntos de contacto dispuestos en el Sitio Web de Comercios (en la
        sección “Contacto”), y deberá abstenerse de utilizar la Herramienta.
      </p>
      <p>
        Si Ud. no acepta los presentes T&C, deberá abstener de utilizar la
        Herramienta.
      </p>
      <p>
        <strong>
          PRIMERO: <u>DEFINICIONES</u>
        </strong>
      </p>
      <ul>
        <li>
          <p>
            <u>Cliente/s:</u> Refiere a la/s persona/s que solicita/n a EDENRED
            la adhesión a cualquiera de las soluciones comercializadas por
            EDENRED, quienes en su relación con EDENRED habilitan e identifican
            a las personas autorizadas para el uso de las
            tarjetas/calcos/NFC/plataformas según el caso (en adelante, los
            “Usuarios”).
          </p>
        </li>
        <li>
          <p>
            <u>Comercio/s:</u> Refiere a todo establecimiento adherido a la red
            de EDENRED que presten sus servicios/expendan bienes bajo la
            modalidad de las Soluciones de EDENRED.
          </p>
        </li>
        <li>
          <p>
            <u>EDENRED:</u> Refiere a EDENRED ARGENTINA S.A.
          </p>
        </li>
        <li>
          <p>
            <u>EMPRESARIAL:</u> Refiere a la solución EDENRED denominada
            “Empresarial” cuyo uso y funcionamiento se indican en el: Formulario
            Solicitud de Incorporación (o actualización de datos) al sistema
            Empresarial Edenred.
          </p>
        </li>
        <li>
          <p>
            <u>Herramienta:</u> Refiere a la herramienta web del Sitio Web de
            Comercios cuyo uso y funcionamiento se indican en los presentes T&C.
          </p>
        </li>
        <li>
          <p>
            <u>Locales:</u> Refiere a los locales en el/los que Ud. desarrolla
            su actividad comercial.
          </p>
        </li>
        <li>
          <p>
            <u>Pagos en Proceso:</u> Refiere a los pagos que debe efectuar
            EDENRED a Ud. para cancelar (por cuenta y orden de los Clientes) las
            facturas emitidas por Ud. por las Transacciones y presentadas a
            EDENRED en tiempo y forma conforme lo previsto en el Reglamento y
            cuya fecha de vencimiento opera dentro de las próximas cuarenta y
            ocho a (48) horas menos (i) los costos y gastos establecidos en el
            Reglamento y (ii) los tributos correspondientes.
          </p>
        </li>
        <li>
          <p>
            <u>Pagos Programados:</u> Refiere a los pagos que debe efectuar
            EDENRED a Ud. para cancelar (por cuenta y orden de los Clientes) las
            facturas emitidas por Ud. por las Transacciones y presentadas a
            EDENRED en tiempo y forma conforme lo previsto en el Reglamento y
            cuya fecha de vencimiento opera en un plazo mayor a cuenta y ocho
            (48) horas hábiles menos (i) los costos y gastos establecidos en el
            Reglamento y (ii) los tributos correspondientes.
          </p>
        </li>
        <li>
          <p>
            <u>Reglamento:</u> Refiere al Reglamento de la/s Solución/es, de
            EDENRED, a las que el Comercio se encuentra adherido junto a la/s
            respectiva/s solicitudes de incorporación que une/n a Ud., como
            Cliente, con EDENRED.
          </p>
        </li>
        <li>
          <p>
            <u>TNM:</u> Refiere a la tasa nominal mensual.
          </p>
        </li>
        <li>
          <p>
            <u>Transacciones:</u> Refiere a las operaciones realizadas por los
            Usuarios con las Soluciones de EDENRED en los Locales de los
            COMERCIOS de la red.
          </p>
        </li>
      </ul>
      <p>
        <strong>
          SEGUNDO: <u>NUEVAS FUNCIONES</u>
        </strong>
      </p>
      <p>
        La Herramienta se encuentra disponible y alojada en el Sitio Web de
        Comercios.
      </p>
      <p>En la Herramienta Ud. podrá visualizar:</p>
      <ul className="list-style-letters">
        <li>
          <p>
            El detalle de las Transacciones, diferenciando aquellas efectuadas
            durante los últimos 12 meses y aquellas efectuadas durante los
            últimos 30 días.
          </p>
        </li>
        <li>
          <p>Pagos en Proceso.</p>
        </li>
        <li>
          <p>Pagos Programados.</p>
        </li>
      </ul>
      <p>
        La Herramienta no permite el pago anticipado de los Pagos en Proceso.
      </p>
      <p>
        Los Pagos en Proceso serán abonados por EDENRED en las fechas pactadas y
        por la vía de pago prevista en el Reglamento.
      </p>
      <p>
        <strong>
          TERCERO: <u>ALTERNATIVAS DE PAGOS EXPRESS</u>
        </strong>
      </p>
      <p>
        La Herramienta le permite a Ud. solicitar a EDENRED el pago anticipado
        total o parcial de los Pagos Programados mediante:
      </p>
      <ul className="list-style-number">
        <li>
          <p>Acreditación en Cuenta.</p>
        </li>
        <li>
          <p>Acreditación en EMPRESARIAL.</p>
        </li>
      </ul>
      <p>
        La utilización de cualquiera de estas alternativas de pago anticipado
        implicará un costo extra y adicional. Dichos costos no aplicarán a Ud.
        si Ud. no utiliza tales alternativas.
      </p>
      <p>
        La alternativa de acreditación en EMPRESARIAL solamente estará
        habilitada para Ud. en caso que Ud. tenga la EMPRESARIAL.
      </p>
      <p>
        Para poder requerir la EMPRESARIAL Ud. deberá realizar el procedimiento
        de solicitud de la misma accediendo al sitio Web en la sección Pago
        Express y cumplir con las condiciones y requisitos allí previstos.
      </p>
      <p>
        Ambas alternativas descriptas se encuentran sujeta a la aceptación y
        aprobación de EDENRED. La selección por el COMERCIO de una o ambas de
        las alternativas no genera en EDENRED la obligación de su aceptación.
        EDENRED se reserva la facultad de discontinuar la herramienta de Pago
        Express, en cualquier momento, para ello bastará informar al comercio
        mediante un aviso en la web respectiva.
      </p>
      <p>
        <strong>
          CUARTO: <u>SOLICITUD DE ACREDITACIÓN EN CUENTA</u>
        </strong>
      </p>
      <p>
        Ud. podrá solicitar a EDENRED que le anticipe parcial o totalmente los
        Pagos Programados mediante transferencia bancaria de las sumas
        respectivas.
      </p>
      <p>
        Los costos por anticipar los Pagos Programados mediante transferencia
        bancaria se corresponderán al siguiente detalle:
      </p>
      <ul className="list-style-roman">
        <li>
          <p>TNM.</p>
        </li>
        <li>
          <p>Gastos administrativos.</p>
        </li>
        <li>
          <p>Impuesto al valor agregado (IVA).</p>
        </li>
      </ul>
      <p>
        El monto específico aplicable por cada uno de tales conceptos y que será
        deducido por EDENRED será informado/visualizado en pantalla de forma
        previa a que Ud. confirme la solicitud del Pago Programado.
      </p>
      <p>
        El saldo resultante entre el “monto solicitado” por Ud. y los “conceptos
        deducidos” por EDENRED será transferido por EDENRED a la cuenta bancaria
        que Ud. informó a EDENRED al momento de adherir al Reglamento dentro de
        las 48hs de efectuada la solicitud.
      </p>
      <p>
        En caso que Ud. solicite la{" "}
        <u>transferencia total de los Pagos Programados</u> a su cuenta bancaria
        y que EDENRED proceda a efectuar la transferencia respectiva, la
        totalidad de las facturas contabilizadas para la fijación de los Pagos
        Programados quedarán totalmente canceladas.
      </p>
      <p>
        En caso que Ud. solicite la{" "}
        <u>transferencia parcial de los Pagos Programados</u> a su cuenta
        bancaria y que EDENRED proceda a efectuar la transferencia respectiva,
        las facturas que fueron contabilizadas para la fijación de los Pagos
        Programados serán canceladas por hasta un monto igual al “monto
        solicitado” por Ud. bajo la Herramienta y por orden cronológico, desde
        las facturas que tengan vencimiento más próximo a vencimiento más lejano
        en el tiempo. Las facturas que correspondan a los Pagos en Proceso serán
        canceladas por EDENRED en las fechas pactadas y por la vía de pago
        establecida en el Reglamento.
      </p>
      <p>
        <strong>
          QUINTO: <u>SOLICITUD DE ACREDITACION EN EMPRESARIAL</u>
        </strong>
      </p>
      <p>
        Ud. podrá solicitar a EDENRED que le anticipe parcial o totalmente los
        Pagos Programados mediante acreditación en la EMPRESARIAL de las sumas
        respectivas.
      </p>
      <p>
        Los costos por anticipar los Pagos Programados mediante acreditación en
        la EMPRESARIAL se corresponderán al siguiente detalle:
      </p>
      <ul className="list-style-roman">
        <li>
          <p>TNM.</p>
        </li>
        <li>
          <p>Gastos administrativos.</p>
        </li>
        <li>
          <p>Impuesto al valor agregado (IVA).</p>
        </li>
      </ul>
      <p>
        El monto específico aplicable por cada uno de tales conceptos y que será
        deducido por EDENRED será informado/visualizado en pantalla de forma
        previa a que Ud. confirme la solicitud del Pago Programado.
      </p>
      <p>
        El saldo resultante entre el “monto solicitado” por Ud. y los “conceptos
        deducidos” por EDENRED será acreditado por EDENRED en EMPRESARIAL dentro
        de las 12 horas hábiles, entendiendo por tales el horario de oficina de
        9 a 18 horas de lunes a viernes, de recibida por EDENRED su solicitud.
      </p>
      <p>
        En caso que Ud. solicite la{" "}
        <u>acreditación total de los Pagos Programados</u> en la EMPRESARIAL y
        que EDENRED proceda a efectuar la acreditación respectiva, la totalidad
        de las facturas contabilizadas para la fijación de los Pagos Programados
        quedarán totalmente canceladas.
      </p>
      <p>
        En caso que Ud. solicite la{" "}
        <u>acreditación parcial de los Pagos Programados</u> en la EMPRESARIAL y
        que EDENRED proceda a efectuar la acreditación respectiva, las facturas
        que fueron contabilizadas para la fijación de los Pagos Programados
        serán canceladas por hasta un monto igual al monto requerido por Ud.
        bajo la Herramienta y por orden cronológico, desde las facturas que
        tengan vencimiento más próximo a vencimiento más lejano en el tiempo.
        Las facturas que correspondan a los Pagos en Proceso serán canceladas
        por EDENRED en las fechas pactadas y por la vía de pago establecida en
        el Reglamento.
      </p>
      <p>
        Los términos de uso de la EMPRESARIAL se indican en: Formulario
        Solicitud de Incorporación (o actualización de datos) al sistema
        Empresarial Edenred.
      </p>
      <p>
        La alternativa Pago Express Acreditación EMPRESARIAL generará para el
        COMERCIO una tarjeta EMPRESARIAL por CUIT. La tarjeta EMPRESARIAL
        emitida a su favor tendrá uso al portador, la selección del
        establecimiento comercial donde la utilice, así como los servicios y
        bienes que Ud. reciba será de su exclusiva responsabilidad y cualquier
        reclamo derivado de ello será atendido por el establecimiento
        seleccionado. Además, siendo la tarjeta EMPRESARIAL al portador, Ud. no
        podrá desconocer las transacciones realizadas con la tarjeta, así como
        tampoco los cargos a través de dichas transacciones generados. Les
        recordamos que la tarjeta EMPRESARIAL no es una tarjeta de la ley
        25.065.
      </p>
      <p>
        En el caso de pérdida/robo/hurto de la tarjeta EMPRESARIAL que Ud. haya
        recibido deberá realizar la denuncia correspondiente por teléfono y por
        email comunicándose por los canales de contacto indicados en la cláusula
        DECIMOQUINTA, dicha denuncia será procesada dentro de las 24 horas
        hábiles de recibida. Toda transacción efectuada con la tarjeta con fecha
        y hora anterior a la del procesamiento por EDENRED de su denuncia no
        podrá ser impugnada.
      </p>
      <p>
        <strong>
          QUINTO: <u>PROHIBICION EXPRESA</u>
        </strong>
      </p>
      <p>
        Ud. tiene estrictamente prohibido manipular, alterar y/o modificar por
        medios informáticos la programación y/o información provista a Ud. a
        través de la Herramienta.
      </p>
      <p>
        <strong>
          SEXTO: <u>LIMITACIÓN DE RESPONSABILIDAD</u>
        </strong>
      </p>
      <p>
        Con la aceptación de estos T&C por parte de Ud. se entenderá de forma
        irrevocable que:
      </p>
      <ul className="list-style-number">
        <li>
          <p>
            Ud. declara reconocer y aceptar que internet es un medio riesgoso e
            inseguro y exonera de toda responsabilidad a EDENRED por cualquier
            virus o malware que pudiera infectar su ordenar como consecuencia
            del uso de la Herramienta, salvo dolo de EDENRED.
          </p>
        </li>
        <li>
          <p>
            Ud. reconoce y acepta que EDENRED no se responsabiliza y es ajeno
            respecto del mérito, oportunidad y conveniencia del uso de la
            Herramienta por parte de Ud., siendo su utilización una facultad
            discrecional suya y no de EDENRED.
          </p>
        </li>
        <li>
          <p>
            EDENRED no garantiza el acceso y el uso continuado o ininterrumpido
            de la Herramienta.
          </p>
        </li>
        <li>
          <p>
            Ud. reconoce y acepta que la Herramienta es un servicio excepcional
            que EDENRED le ofrece y que puede eventualmente no estar
            disponible/accesible por razones ajenas a EDENRED o por decisión
            propia de EDENRED, incluyendo las tareas de mantenimiento
            informático del Sitio Web de Comercios y/o de la Herramienta que
            lleve a cabo EDENRED. El no funcionamiento de la Herramienta por los
            motivos antedichos no otorgará a Ud. derecho a resarcimiento ni
            reclamo alguno.
          </p>
        </li>
        <li>
          <p>
            El sistema puede eventualmente no estar disponible debido a
            dificultades técnicas o fallas de Internet, o por cualquier otra
            circunstancia ajena a EDENRED; en tales casos se procurará
            restablecerlo con la mayor celeridad posible sin que por ello pueda
            imputársele a EDENRED algún tipo de responsabilidad.
          </p>
        </li>
        <li>
          <p>
            EDENRED no se responsabiliza por los daños y perjuicios que Ud.
            pudiera sufrir como consecuencias del uso y/o mal uso de la
            Herramienta por parte de Ud.
          </p>
        </li>
      </ul>
      <p>
        <strong>
          SEPTIMO: <u>SUSPENSION DEFINITIVA DE LA HERRAMIENTA</u>
        </strong>
      </p>
      <p>
        EDENRED podrá, en cualquier momento y a su sola discreción, suspender
        definitivamente la operatividad de la Herramienta. Ello no otorgará a
        Ud. derecho a reclamo o compensación alguna.
      </p>
      <p>
        <strong>
          OCTAVO: <u>ALMACENAMIENTO DE DATOS</u>
        </strong>
      </p>
      <p>
        Cuando Ud. utilice la Herramienta, EDENRED almacenará las
        instrucciones/solicitudes que efectúe con la misma.
      </p>
      <p>
        Tales instrucciones/solicitudes serán almacenadas a fin de su
        procesamiento y debido registro.
      </p>
      <p>
        EDENRED podrá transferir el detalle de las distintas
        instrucciones/solicitudes efectuadas por Ud. a cualquiera de las
        sociedades relacionadas, afiliadas, controladas, controlantes, filiales,
        representaciones o vinculadas de EDENRED, y a terceros proveedores de
        servicios de procesamiento y tratamiento de datos.
      </p>
      <p>
        Ud., reconoce y acepta que EDENRED podrá transmitir/compartir el detalle
        de tales instrucciones/solicitudes con autoridades públicas,
        administrativas o judiciales, a fin de dar cumplimiento a los
        requerimientos normativos/judiciales que puedan efectuársele a EDENRED.
      </p>
      <p>
        EDENRED almacena la información en sus servidores ubicados físicamente
        en el Data Center KIO Edenred México y en el Cloud DXC USA. Sin
        perjuicio de ello, EDENRED se reserva el derecho de reubicar en
        cualquier otro país estos servidores a su sola discreción, lo cual Ud.
        acepta y autoriza expresamente. En tal caso, EDENRED se compromete a
        garantizar el cumplimiento de los estándares exigidos por la normativa
        vigente de Argentina en materia de confidencialidad y protección de
        datos personales. EDENRED se compromete a guardar confidencialidad de
        sus datos y a efectuar esfuerzos razonables para mantener sistemas de
        seguridad adecuados para el tipo de información almacenada en sus
        servidores. No obstante ello, EDENRED no garantiza a Ud. la
        inviolabilidad de los mismos.
      </p>
      <p>
        EDENRED reconoce los derechos de acceso, rectificación, actualización y
        eliminación de sus datos.
      </p>
      <p>
        Para ejercer tales derechos Ud. deberá remitir a EDENRED una solicitud
        en tal sentido (la “Solicitud”), mediante:
      </p>
      <ul>
        <li>
          <p>
            Una presentación en las oficinas de EDENRED, sitas en Óptima
            Business Park Alferez Hipólito Bouchard 4169/4191, 7° piso. Munro,
            Buenos Aires, Argentina.
          </p>
        </li>
      </ul>
      <p>
        La Solicitud deberá contener su número de COMERCIO afiliado, nombre y
        apellido/razón social, número de documento y copia simple del mismo,
        dirección de correo electrónico, domicilio, y número telefónico.
        Asimismo, deberá contener una descripción clara y precisa de los datos
        respecto de los cuales busca ejercer el derecho de acceso,
        rectificación, actualización o eliminación y una descripción de los
        hechos que motivan tal solicitud. En caso de modificación/actualización
        de datos, Ud. deberá acompañar los documentos que sustenten el cambio
        solicitado.
      </p>
      <p>
        EDENRED cuenta con 10 (diez) días hábiles desde la recepción de la
        Solicitud para expedirse en los casos de pedido de acceso (art. 14 de la
        LDPD) y con 5 (cinco) días hábiles si Ud. hubiere solicitado la
        rectificación, actualización, o la eliminación de sus datos (art. 16 de
        la LDPD).
      </p>
      <p>
        EDENRED sólo procederá a la supresión de sus datos si no hubiera ningún
        contrato vigente que uniera a las Partes y Ud. no mantuviera con EDENRED
        ninguna deuda (sea o no líquida y exigible).
      </p>
      <p>
        Ud. podrá ejercer estos derechos en forma gratuita en intervalos no
        inferiores a 6 (seis) meses, salvo que acredite un interés legítimo al
        efecto (art. 14 inciso 3 de la LDPD). Se le hace saber que la Agencia de
        Acceso a la Información Pública (ex Dirección Nacional de Protección de
        Datos Personales), como órgano de control de la Ley de Protección de
        Datos Personales, tiene la atribución de atender denuncias y reclamos
        con relación al incumplimiento de las normas sobre protección de datos
        personales (conf. artículo 2 de la Disposición 10/08 de la Dirección
        Nacional de Protección de Datos Personales). Para contactar a la misma
        deberá dirigirse a: Agencia de Acceso a la Información Pública, Av. Pte.
        Gral. Julio A. Roca 710, piso 2do, Ciudad Autónoma de Buenos Aires.
        T.E.011-2821-0047{" "}
        <a href="https://www.argentina.gob.ar/aaip">
          https://www.argentina.gob.ar/aaip
        </a>
        .
      </p>
      <p>
        EDENRED conservará sus datos durante toda la vigencia de la relación
        comercial, y por un plazo de cinco (5) años a contarse desde la
        terminación del vínculo contractual que una a Ud. con EDENRED. Vencido
        dicho plazo, procederemos a eliminar sus datos de nuestra base de datos.
      </p>
      <p>
        <strong>
          NOVENA: <u>COOKIES</u>
        </strong>
      </p>
      <p>
        Para mejorar el funcionamiento del Sitio Web de Comercios, y brindar una
        experiencia de uso más eficiente, dinámica y personalizada de la
        Herramienta, Ud. reconoce y acepta que hay cierta información personal
        que recopilamos cada vez que Ud. accede al Sitio Web de Comercios y/o a
        la Herramienta. Una cookie es un archivo de texto informático que se
        almacena en su navegador web y tiene el objeto, entre otros, de
        proporcionar la información necesaria para recordar sus datos de ingreso
        y cualquier información relacionada con su cuenta, de ayudar a
        personalizar las propuestas de servicios y promociones dirigidas a Ud.,
        y de brindar mayor eficiencia al funcionamiento del Sitio Web de
        Comercios y/o de la Herramienta (como puede ser, por ejemplo, el sistema
        operativo del cual accede, fechas y horas de utilización del Sitio Web
        de Comercios, etc.).
      </p>
      <p>
        <strong>
          DECIMA: <u>PROPIEDAD INTELECTUAL</u>
        </strong>
      </p>
      <p>
        Ud. reconoce y acepta que EDENRED es el único y exclusivo titular de
        todo derecho sobre el Sitio Web de Comercios y la Herramienta, como así
        también de todas las derivaciones, modificaciones y mejoras efectuadas a
        los mismos, y de todo logo, emblema, logotipo, diseño, contenido, etc.
        que forme parte de los mismos (incluyendo pero no limitando, la
        titularidad de todos los derechos de propiedad intelectual).
      </p>
      <p>
        Ud. declara comprender u aceptar que EDENRED no le otorga el título o la
        propiedad del Sitio Web de Comercios ni de la Herramienta y/o sus
        derivaciones modificaciones y mejoras, sino sólo un derecho de uso
        limitado.
      </p>
      <p>
        Ud. se compromete a informar a EDENRED en forma inmediata respecto de
        toda violación y otra acción indebida a la que tome conocimiento con
        respecto a la propiedad intelectual de EDENRED.
      </p>
      <p>
        <strong>
          UNDECIMA: <u>CESIÓN DE POSICION CONTRACTUAL</u>
        </strong>
      </p>
      <p>
        Ud. no podrá ceder ni transferir su posición contractual ni sus derechos
        y obligaciones emergentes de la aceptación de los presentes T&C.
      </p>
      <p>
        EDENRED podrá transferir su posición contractual, así como los derechos
        y obligaciones emergentes de los presentes T&C con la sola obligación de
        notificar ello a Ud.
      </p>
      <p>
        <strong>
          DUODECIMO: <u>INTEGRACION DE TERMINOS Y CONDICIONES</u>
        </strong>
      </p>
      <p>
        La Herramienta se rige por los términos y condiciones establecidos en
        los presentes T&C y también por los términos y condiciones del Sitio Web
        de Comercio y su respectiva política de privacidad.
      </p>
      <p>
        <strong>
          DECIMOTERCERO: <u>ACTUALIZACIÓN DE LOS T&C</u>
        </strong>
      </p>
      <p>
        EDENRED se reserva el derecho de modificar y enmendar en cualquier
        momento estos T&C. Dichas modificaciones serán comunicadas a Ud. y
        requerirá de su lectura y aceptación. Todos los términos modificados
        entrarán en vigor a partir del día en que fueran informados.
      </p>
      <p>
        Como consecuencia de lo anterior, recomendamos a Ud. leer los presentes
        T&C y toda modificación de los mismos de forma previa a utilizar la
        Herramienta. Si Ud. no acepta las modificaciones a los T&C deberá
        abstener de utilizar la Herramienta.
      </p>
      <p>
        <strong>
          DECIMOCUARTO: <u>LEY APLICABLE Y JURISDICCIÓN</u>
        </strong>
      </p>
      <p>
        Los presentes T&C serán regidos e interpretados de conformidad con las
        leyes de la República Argentina.
      </p>
      <p>
        Las disputas, controversias o reclamaciones en relación con la
        ejecución, cumplimiento o interpretación del presente serán sometidas a
        la jurisdicción de los Tribunales Nacionales Ordinarios con asiento en
        la Ciudad Autónoma de Buenos Aires, renunciando a cualquier otra
        jurisdicción que pudiera corresponder.
      </p>
      <p>
        <strong>
          DECIMOQUINTO: <u>CANALES DE CONTACTO</u>
        </strong>
      </p>
      <address>
        <p>Nuestros canales de contacto son:</p>
        <p>Telefónico 4909 1400 </p>
        <p>
          E-mail{" "}
          <a href="mailto:cliente-ar@edenred.com">cliente-ar@edenred.com</a>
        </p>
      </address>
      <p></p>
    </span>
  );
};
